import { createFileRoute, redirect } from '@tanstack/react-router'
import { UserList } from '@/features/users/user-list'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the members screen — design 1d's "members" view.
 *
 * The route lives under `_authenticated` so the layout's `beforeLoad`
 * guard ensures the session is populated before the screen mounts.
 * The list screen reads the active company from `meQuery` and the
 * members from `/api/companies/{c}/members`; both calls hit the
 * api-client, which carries the Sanctum session cookie.
 *
 * The grant guard below is presentation only. The API enforces `user.view`
 * on every membership endpoint, so a stale grant still 403s server-side;
 * this only keeps a user without the grant out of a screen they cannot use.
 *
 * Per the route-shell rule in `apps/company/AGENTS.md`, this file is
 * a route definition and a render of a feature. Everything else (the
 * list, the invite dialog, the member-edit dialog) lives in
 * `src/features/users/`.
 */
export const Route = createFileRoute('/_authenticated/users')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'user.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: UserList,
})
